<template>
	<TnTextField
		v-bind="formElementModel"
		:label="formElementModel.text"
		v-model="modelValue"
		:dark="dark"
		@update:modelValue="handleInput"
	>
		<template
			v-if="hasError"
			#error
		>
			{{ validationText }}</template
		>
	</TnTextField>
</template>

<script setup>
import { useFormStore } from "~/pinia/platform/form/form.ts";

const props = defineProps({
	component: {
		type: Object,
		required: true,
	},
	dark: Boolean,
});

const hasError = ref(false);

const { modelValue, validationText } = useFormElement(props.component);
const formElementModel = useFormElement(props.component);

const emit = defineEmits(["update", "error"]);

function handleInput(value) {
	modelValue.value = value;
	emit("update", value);
	if (!value.length && formElementModel.required) {
		validationText.value = "Dette feltet er obligatorisk";
		hasError.value = true;
		emit("error", hasError.value);
		return;
	}

	validationText.value = "";
	hasError.value = false;

	emit("error", hasError.value);
	useFormStore().setFormFieldValue({ name: formElementModel.name, value });
}
</script>
